export default __webpack_public_path__ + "static/media/UserGuide_cs_CZ.db95b795.pdf";